import { findMockHandler } from "./mockHandlers";

const STORAGE_KEY = "spartacus:mock-enabled";
let interceptorId = null;

function isMockEnabled() {
  return localStorage.getItem(STORAGE_KEY) === "true";
}

/**
 * Install mock interceptor on an axios instance.
 * When mocks are enabled, matching requests return fake data
 * with a small delay to simulate network latency.
 * Unmatched requests pass through to the real API.
 */
export function installMockInterceptor(axiosInstance) {
  if (interceptorId !== null) return;

  interceptorId = axiosInstance.interceptors.request.use(
    async (config) => {
      if (!isMockEnabled()) return config;

      const handler = findMockHandler(config.url, config.method);
      if (!handler) return config;

      const mockData = handler(config);
      if (mockData === null) return config;

      // Simulate network delay
      await new Promise((r) => setTimeout(r, 300 + Math.random() * 400));

      // Create a fake response by using adapter override
      config.adapter = () =>
        Promise.resolve({
          data: mockData,
          status: 200,
          statusText: "OK (Mock)",
          headers: { "x-mock": "true" },
          config,
        });

      return config;
    },
    (error) => Promise.reject(error)
  );
}

export function removeMockInterceptor(axiosInstance) {
  if (interceptorId !== null) {
    axiosInstance.interceptors.request.eject(interceptorId);
    interceptorId = null;
  }
}
